// Dati del profilo SmartCV (Il mio CV). Per ora solo in memoria: le API di lettura/salvataggio
// non esistono ancora, quindi ricaricando la pagina i dati si perdono.
export default () => ({
  // true dopo una modifica non ancora salvata (abilita SALVA PROFILO)
  changed: false,
  languages: [],
  education: [],
  experiences: [],
  skills: [],
  courses: [],
  licences: [],
  hasCar: false,
  // Altro: Categorie Protette, Lavoratore Autonomo, Disoccupato
  other: {
    protectedCategory: false,
    selfEmployed: false,
    unemployed: false
  }
})
